var map = {
	"./Checkbox.svg": 77104,
	"./Checkbox_Icon_DropDown.svg": 19748,
	"./Close_Icon.svg": 36695,
	"./Delete_Icon.svg": 54807,
	"./Dislike_Icon.svg": 5849,
	"./DropDown_Icon.svg": 81610,
	"./Edit_Icon.svg": 73235,
	"./Figma-Illu.svg": 86812,
	"./Github-Illu.svg": 1429,
	"./Github_Icon.svg": 80132,
	"./Like_Icon.svg": 61456,
	"./Logo.svg": 10854,
	"./Plus_Icon.svg": 92152,
	"./Premiere-Illu.svg": 8396,
	"./Premiere_Icon01.svg": 64651,
	"./Save_Icon.svg": 82362,
	"./Search_Icon.svg": 46638,
	"./Share_Icon.svg": 15009,
	"./Share_Icon02.svg": 38485,
	"./Striche_Icon.svg": 65350,
	"./TogelIcon.svg": 85883,
	"./Toggel_active_Icon.svg": 78962,
	"./UX_UI_Icon.svg": 3629,
	"./favicon.svg": 46034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77970;